import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/common/ui/table";

import type { RecentQuery } from "./rag-quality-types";

interface RecentQueriesTableProps {
  queries: RecentQuery[];
}

function formatTimestamp(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function RecentQueriesTable({ queries }: RecentQueriesTableProps): React.ReactElement {
  return (
    <div data-testid="recent-queries-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Time</TableHead>
            <TableHead>Query</TableHead>
            <TableHead className="text-right">Sources Cited</TableHead>
            <TableHead className="text-right">Top Score</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {queries.map((query) => (
            <TableRow key={query.id} data-testid={`query-row-${query.id}`}>
              <TableCell className="whitespace-nowrap text-muted-foreground">
                {formatTimestamp(query.timestamp)}
              </TableCell>
              <TableCell className="max-w-xs truncate" title={query.query_excerpt}>
                {query.query_excerpt}
              </TableCell>
              <TableCell className="text-right">{query.sources_cited_count}</TableCell>
              <TableCell className="text-right">
                {query.top_score !== null ? query.top_score.toFixed(2) : "\u2014"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
